import { render, staticRenderFns } from "./SubscriptionRulesTable.vue?vue&type=template&id=6a566e82"
import script from "./SubscriptionRulesTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionRulesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports